import React from 'react';

export default class MultiSelectToggleView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: this.props.selection.length > 0 
        };
    }

    toggleVisibility() {
        this.setState({ visible: !this.state.visible });
    }

    onSelection(value, event) {
        const selection = value.key;
        const selected = event.target.checked ? [...this.props.selection, selection] : this.props.selection.filter(s => s !== selection);
        this.props.update(this.props.propertyName, selected);
    }

    render() {
        return (
            <div className={this.state.visible ? "custom-add custom-add-open" : "custom-add"}>
                <div className="custom-add-header">
                    <p>{this.props.title}</p>
                    <i className="material-icons" onClick={this.toggleVisibility.bind(this)}>{this.state.visible ? "remove" : "add"}</i>
                </div>
                <div className="custom-add-body">
                    {this.props.options.map(option => {
                        const checkboxId = `${this.props.propertyName}-${option.key}`;
                        return <div key={checkboxId} className="custom-check-container">
                            <input type="checkbox" id={checkboxId} className="custom-check"
                                checked={this.props.selection.indexOf(option.key) >= 0}
                                onChange={this.onSelection.bind(this, option)} />
                            <label htmlFor={checkboxId} className="secondary-text">{option.value}</label>
                        </div>
                    })}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/MultiSelectToggleView.jsx